// jshint esversion: 8

export default {
  types: [],
  typesMap: {},
  indexByTypeMap: {},
  ratesByTypeMap: {}
};
